@if (hasFilters || showMobileSort) {
  <div class="filter-chips">
    @if (showMobileSort) {
      <button class="chip sort-chip" type="button" (click)="sortBadgeClicked.emit()">
        <span [fiTranslation]="sortLabelKey" [replaceKeys]="true"></span>
      </button>
    }
    @if (hasDateFilter) {
      <button class="chip" type="button">
        <span>{{ dateRangeLabel }}</span>
        <mat-icon (click)="clearDateFilter($event)">close</mat-icon>
      </button>
    }
    @if (filters.leadTypes) {
      @for (item of filters.leadTypes; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.Description.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.leadTypes, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.premiumProjectCustomerTypes) {
      @for (item of filters.premiumProjectCustomerTypes; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span [fiTranslation]="item.Text"></span>
          <mat-icon (click)="remove(filters.premiumProjectCustomerTypes, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.contactTypes) {
      @for (item of filters.contactTypes; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.Description.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.contactTypes, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.leadStatuses) {
      @for (item of filters.leadStatuses; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.Text.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.leadStatuses, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.countries) {
      @for (item of filters.countries; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.Name.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.countries, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.deadlineStatus) {
      @for (item of filters.deadlineStatus; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span [fiTranslation]="item.Text"></span>
          <mat-icon (click)="remove(filters.deadlineStatus, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.commissionSearches) {
      @for (item of filters.commissionSearches; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.commissionSearches, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.contactSearches) {
      @for (item of filters.contactSearches; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.contactSearches, i)">close</mat-icon>
        </button>
      }
    }
    @if (filters.responsibleSearches) {
      @for (item of filters.responsibleSearches; track trackByIndex(i, item); let i = $index) {
        <button class="chip" type="button">
          <span>{{ item.toLowerCase() }}</span>
          <mat-icon (click)="remove(filters.responsibleSearches, i)">close</mat-icon>
        </button>
      }
    }
    @if (hasFilters) {
      <button class="clear-all f_remove_all_filters" type="button" (click)="allFiltersRemoved.emit()">
        <span fiTranslation="REQUEST_OVERVIEW_FILTER_CANCEL"></span>
      </button>
    }
  </div>
}
